import axios from '@/axios/axios2'

// 查询累计商户数
export const getCumulative = params =>
  axios.post('/statistics/getCumulative', params)
